import './TableCustomTabs.scss';

export const TableCustomTabs = ({tabs, onTabChange, active}) => (
	<div className={'table-custom-tabs'}>
		{tabs.map(tab => <button className={`table-custom-tab ${active === tab ? 'active' : 'disabled'}`} key={tab} onClick={() => onTabChange(tab)}>{tab}</button>)}
	</div>
);